import React from 'react';

type Props = {
  children: React.ReactNode;
  title: string;
  body?: boolean;
  transparent?: boolean
}

export function SectionBlock(props: Props) {
  props = {
    transparent: false,
    body: true,
    ...props
  }

  return (
    <div className='element-wrapper'>
      <h6 className='element-header'>
        { props.title }
      </h6>
      <div className={ props.body ? (props.transparent ? 'element-box-tp' : 'element-box') : '' }>
        { props.children }
      </div>
    </div>
  );
}